// Enhanced GTranslate Scroll Behavior
function initEnhancedGTranslateScroll() {
  const langSwitcher = document.querySelector('.gt-selected');
  if (!langSwitcher) {
    setTimeout(initEnhancedGTranslateScroll, 1000);
    return;
  }

  const config = {
    headerThreshold: 150,
    footerThreshold: 200,
    scrollDebounce: 50,
    showDuration: 3000 // Show for 3 seconds when triggered
  };

  let scrollTimeout;
  let hideTimeout;
  let isVisible = false;

  function handleScroll() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(checkScrollPosition, config.scrollDebounce);
  }

  function checkScrollPosition() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    
    const nearTop = scrollTop <= config.headerThreshold;
    const scrollBottom = scrollTop + windowHeight;
    const nearBottom = scrollBottom >= (documentHeight - config.footerThreshold);
    
    if (nearTop || nearBottom) {
      showLangSwitcher();
    } else if (isVisible) {
      // Only hide if not manually interacting
      if (!langSwitcher.matches(':hover')) {
        hideLangSwitcher();
      }
    }
  }

  function showLangSwitcher() {
    clearTimeout(hideTimeout);
    if (!isVisible) {
      langSwitcher.classList.add('show-on-scroll');
      isVisible = true;
    }
    
    // Auto-hide after duration (unless hovering)
    hideTimeout = setTimeout(() => {
      if (!langSwitcher.matches(':hover')) {
        hideLangSwitcher();
      }
    }, config.showDuration);
  }

  function hideLangSwitcher() {
    langSwitcher.classList.remove('show-on-scroll');
    isVisible = false;
  }

  // Keep visible when hovering
  langSwitcher.addEventListener('mouseenter', () => {
    clearTimeout(hideTimeout);
  });

  langSwitcher.addEventListener('mouseleave', () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollBottom = scrollTop + windowHeight;
    
    const nearTop = scrollTop <= config.headerThreshold;
    const nearBottom = scrollBottom >= (documentHeight - config.footerThreshold);
    
    if (!nearTop && !nearBottom) {
      hideTimeout = setTimeout(hideLangSwitcher, 1000);
    }
  });

  // Initial setup
  checkScrollPosition();
  window.addEventListener('scroll', handleScroll, { passive: true });
  window.addEventListener('resize', checkScrollPosition, { passive: true });
}

// Initialize
document.addEventListener('DOMContentLoaded', initEnhancedGTranslateScroll);